module.exports = __webpack_public_path__ + "static/media/checkin.12592679.svg";